import { AlarmType } from "./alarm.types";

export const alarmLabelKeys: Record<AlarmType, string> = {
  PoiAlarm: "alarm.poi_outside_time",
  AbsenceOfTransmission: "alarm.no_transmission",
  AccelerometreAlarm: "alarm.accelerometer",
  AuthentificationButtonAlarm: "alarm.ibutton_auth",
  BrouillageGPSAlarm: "alarm.gps_jamming",
  BrouillageGSMAlarm: "alarm.gsm_jamming",
  CANAlarm: "alarm.can",
  SIMCreditAlarm: "alarm.sim_credit",
  GroupeButtonAlarm: "alarm.ibutton_group",
  "I/O Alarm": "alarm.io",
  PrivateModeAlarm: "alarm.private_mode",
  specificButtonAlarm: "alarm.ibutton_specific",
  powerAlarm: "alarm.power_cut",
  BatteryAlarm: "alarm.battery",
  MotionSensor: "alarm.motion",
  DateTimeAlarm: "alarm.datetime",
  SpeedExceedAlarm: "alarm.speed_exceed",
  ButtonErreur: "alarm.ibutton_error",
  "Motor Contact Status": "alarm.ignition",
  RelayStatus: "alarm.relay_status",
  "Panic state": "alarm.panic",
  IncrementCounterEV1: "alarm.ev1",
  IncrementCounterEV2: "alarm.ev2",
  InterfaceOrGarminScreenDisconnected: "alarm.garmin_disconnected",
  EngineStartedDuringRestrictedTime: "alarm.engine_restricted",
  MovementWithEngineOff: "alarm.movement_engine_off",
  MemoryFull: "alarm.memory_full",
  GPSSignalAlarm: "alarm.gps_signal",
  GsmSignalAlarm: "alarm.gsm_signal",
  ResetAlarm: "alarm.reset",
  OdometerCAN: "alarm.odometer_can",
  OdometerGPS: "alarm.odometer_gps",
  PointsOfInterest: "alarm.poi",
  RelayActivated: "alarm.relay_on",
  RelayDisconnected: "alarm.relay_off",
  EngineSpeedCAN: "alarm.engine_speed",
  UnknownGSMNetwork: "alarm.unknown_gsm",
  InvalidGPSSignal: "alarm.invalid_gps",
  UnderVoltage: "alarm.under_voltage",
  ParkingWithEngineOn: "alarm.idling",
  ParkingWithEngineOnDevice: "alarm.idling_device",
  ParkingWithEngineOff: "alarm.parked_engine_off",
  StationaryWithEngineOn: "alarm.idling",
  StationaryWithEngineOnDevice: "alarm.idling_device",
  StationaryWithEngineOff: "alarm.parked_engine_off",
  OverVoltage: "alarm.over_voltage",
  EngineTemperatureCAN: "alarm.engine_temp",
  DailyMobileData: "alarm.daily_data",
  MonthlyMobileData: "alarm.monthly_data",
  Speeding: "alarm.speeding",
  POIEntryExit: "alarm.poi_entry_exit",
  POISpeedViolation: "alarm.poi_speed",
};
